import React, { useState } from 'react';

import './RydCollapsableCard.css';
import { normalizeClassName } from '../../render/renderUtils';
// import React, { useState, useRef, useLayoutEffect, useCallback } from 'react';
export function RydCollapsableCard({
    title,
    children,
    collapsed = false,
    style = {}
} : {
    title: string,
    children: React.ReactNode,
    collapsed?: boolean,
    style?: React.CSSProperties
}) {
    const [isCollapsed, setIsCollapsed] = useState(collapsed);

    const toggleVisibility = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div className={normalizeClassName(["ryd-collapsable-card", !isCollapsed ? "expanded" : "collapsed"])} style={style}>
            <div
                className="ryd-card-header"
                onClick={toggleVisibility}
                style={{ cursor: 'pointer', userSelect: 'none' }}
            >
                {title} {isCollapsed ? '▼' : '▲'}
            </div>
            <div className="ryd-card-content">{children}</div>
        </div>
    );
};